module.exports = __webpack_public_path__ + "img/good.d22a395b.svg";